export const getAmountByCurrency = (price, currency) => {
    const { convertedAmountList } = price || {};
    if (convertedAmountList) {
        const getBaseAmount = amount => (amount ? amount.amount : undefined);
        return getBaseAmount(convertedAmountList.find(amount => amount.currency === currency));
    }
    return undefined;
};
